import React, { useEffect, useState, useRef } from 'react'
import NumberFormat from 'react-number-format'
import ErrorMessage from '../../common/ErrorMessage'
import SuccessMessage from '../../common/SuccessMessage'
import { useNavigate, useParams } from 'react-router-dom';
import constant from '../../../constant'

export default function CreateForumCategory(props) {
    const { detail } = props
    const { id } = useParams()
    const Navigate = useNavigate()
    const [error, setError] = useState(false)
    const [data, setData] = useState({
        DISCUSSION_CATEGORY_TITLE: "",
        DISCUSSION_CATEGORY_DETAILS: "",
        SORT_NUMBER: ""
    })

    const handleChange = e => {
        const { name, value } = e.target
        setData({
            ...data,
            [name]: value
        })

    }

    const handleReset = (e) => {
        setError(false)
        e.preventDefault();
        id && Navigate(constant.component.Discussionforum.url)
        setData(PrevState => ({
            ...PrevState,
            DISCUSSION_CATEGORY_TITLE: "",
            DISCUSSION_CATEGORY_DETAILS: "",
            SORT_NUMBER: ""
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (data.DISCUSSION_CATEGORY_TITLE.trim().length == 0 || data.SORT_NUMBER.toString().trim().length == 0) {
            setError(true)
        }
        else {
            const model = {
                DISCUSSION_CATEGORY_TITLE: data.DISCUSSION_CATEGORY_TITLE,
                DISCUSSION_CATEGORY_DETAILS: data.DISCUSSION_CATEGORY_DETAILS,
                SORT_NUMBER: data.SORT_NUMBER
            };
            // if (detail) {
            //     model.SKILL_ID = detail.SKILL_ID
            props.onSubmit(model)
        }
    }

    return (
        <React.Fragment>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0" style={{ fontSize: "18px" }}>Add Discussion Forum</h4>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Utilities</a></li>
                                            <li className="breadcrumb-item active">Add Discussion Forum</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Category Information</h4>
                                        {
                                            props.showMsg && (props.response.status ?
                                                <SuccessMessage message={props.response.messageCode} />
                                                :
                                                <ErrorMessage message={props.response.error} />)
                                        }
                                        <div id="basic-example">
                                            <section>
                                                <form method="POST">
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <label for="basicpill-firstname-input">Category Title<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    className={error && data.DISCUSSION_CATEGORY_TITLE.trim().length == 0 ? 'form-control is-invalid ' : 'form-control'}
                                                                    type="text"
                                                                    id="basicpill-firstname-input"
                                                                    placeholder="Enter Category"
                                                                    name="DISCUSSION_CATEGORY_TITLE"
                                                                    value={data.DISCUSSION_CATEGORY_TITLE}
                                                                    onChange={handleChange}
                                                                />
                                                                {error && data.DISCUSSION_CATEGORY_TITLE.trim().length == 0 ? <span className='text-danger ml-1'> This Field is Required</span> : ''}
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <label for="basicpill-address-input">Sort Number<span style={{ color: 'red' }}>*</span></label>
                                                                <NumberFormat
                                                                    className={error && data.SORT_NUMBER.toString().trim().length == 0 ? 'form-control is-invalid ' : 'form-control'}
                                                                    type="text"
                                                                    // className="form-control"
                                                                    id="basicpill-firstname-input"
                                                                    placeholder="Enter Sort Number"
                                                                    name="SORT_NUMBER"
                                                                    maxLength={10}
                                                                    value={data.SORT_NUMBER}
                                                                    onChange={handleChange}
                                                                />
                                                                {error && data.SORT_NUMBER.toString().trim().length == 0 ? <span className='text-danger ml-1'> This Field is Required</span> : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">

                                                        <div className="col-lg-12">
                                                            <div className="mb-3">
                                                                <label for="basicpill-address-input">Category Details</label>
                                                                <textarea
                                                                    id="basicpill-address-input"
                                                                    className="form-control"
                                                                    rows="2"
                                                                    placeholder="Enter Category Details"
                                                                    name="DISCUSSION_CATEGORY_DETAILS"
                                                                    value={data.DISCUSSION_CATEGORY_DETAILS}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <button type="button" onClick={(e) => onSubmit(e)} className="btn btn-info waves-effect btn-label waves-light"><i className="bx bx-check-double label-icon"></i> Create Category</button>
                                                                &nbsp;&nbsp;
                                                                <button type="button" onClick={(e) => handleReset(e)} className="btn btn-danger waves-effect btn-label waves-light"><i className="bx bx-block label-icon "></i> Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </section>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}



